/*tslint:disable*/
/*eslint-disable*/
//This file was automatically generated and should not be edited.
import gql from 'graphql-tag';
export const Query_Series = gql`
  query Query_Series($id: ID!) {
    Series(id: $id) {
      __typename
      id
      title
      url_title
      path
      full_url
      localized_path
      entry_date {
        yyyymmdd
      }
      edit_date {
        yyyymmdd
      }
      language
      cast
      hero(params: { width: 1600 }) {
        processed_url
      }
      thumbnail {
        processed_url
      }
      trailer {
        brightcove_id
      }
      description
      short_description
      seasons {
        id
        seasonNum
        title
        next_episode_release_date {
          iso8601
        }
        episodes {
          id
          seasonNum
          episodeNum
          title
          media {
            brightcove_id
          }
          media_duration {
            seconds
            minutes
          }
          cast
          hero {
            processed_url
          }
          thumbnail {
            processed_url
          }
          trailer {
            brightcove_id
          }
          description
          short_description
        }
      }
    }
  }
`;
